export default __webpack_public_path__ + "static/media/up.edc305ea.svg";